export enum EHorizontalSignTextAlignment {
  EHSTA_Left,
  EHSTA_Center,
  EHSTA_Right,
}

export const EHorizontalSignTextAlignmentDisplayName = {
  [EHorizontalSignTextAlignment.EHSTA_Left]: 'Left',
  [EHorizontalSignTextAlignment.EHSTA_Center]: 'Center',
  [EHorizontalSignTextAlignment.EHSTA_Right]: 'Right',
};
